// Return the parent dresses position in the scroll
export var getRootOffset = function getRootOffset(image) {
  return image.offsetLeft + image.parentElement.offsetLeft + image.parentElement.parentElement.offsetLeft + window.innerHeight;
};